import RegistryOperatorGarbageTable from './registry/components/registry-operator-garbage-table.vue'
import RegistryOperatorGarbageTableOrenb from './registry/region.orenb/components/registry-operator-garbage-table.vue'
import AnalyticReportApoSelector from './analytic/components/analytic-report-apo-selector.vue'
import RegistryTransportTableHmao from './registry/region.hmao/components/transport-table'
import RegistryTransportTableMariel from './registry/region.mariel/components/transport-table'
import RegistryOperatorObjectsTable from './registry/components/operator-objects-table.vue'
import RegistryOperatorObjectsTableKrasn from './registry/region.krasn/components/operator-objects-table.vue'

import GarbageOperation from './garbage/components/garbage-operation.vue'
import GarbageOperationKrasnKarelSaas from './garbage/region.krasn.karel.saas/components/garbage-operation.vue'

import RegistryObjectGarbageTable from './registry/components/registry-object-garbage-table'
import RegistryObjectGarbageTableKrasn from './registry/region.krasn/components/registry-object-garbage-table'

import RegistryTransportTableOrenb from './registry/components/transport-table'

import region from '../utils/region.js'
import {ORENB, HMAO, KRASN, KAREL, SAAS, MARIEL} from '../config/region.js'
import componentGlobalSaver from '../utils/componentGlobalSaver'
// src/app/geo/components uses local import

export default function (Vue) {
  let currentRegion = region.getCurrentRegion()

  // defaults
  componentGlobalSaver.registerGlobalAndSave(Vue, RegistryOperatorGarbageTable)
  componentGlobalSaver.registerGlobalAndSave(Vue, AnalyticReportApoSelector)
  componentGlobalSaver.registerGlobalAndSave(Vue, RegistryOperatorObjectsTable)
  componentGlobalSaver.registerGlobalAndSave(Vue, GarbageOperation)
  componentGlobalSaver.registerGlobalAndSave(Vue, RegistryObjectGarbageTable)

  if (currentRegion === ORENB) {
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryOperatorGarbageTableOrenb)
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryTransportTableOrenb)
  }

  if (currentRegion === HMAO) {
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryTransportTableHmao)
  }

  if (currentRegion === MARIEL) {
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryTransportTableMariel)
  }

  if (currentRegion === KRASN) {
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryOperatorObjectsTableKrasn)
    componentGlobalSaver.registerGlobalAndSave(Vue, GarbageOperationKrasnKarelSaas)
    componentGlobalSaver.registerGlobalAndSave(Vue, RegistryObjectGarbageTableKrasn)
  }

  if (currentRegion === KAREL) {
    componentGlobalSaver.registerGlobalAndSave(Vue, GarbageOperationKrasnKarelSaas)
  }

  if (currentRegion === SAAS) {
    componentGlobalSaver.registerGlobalAndSave(Vue, GarbageOperationKrasnKarelSaas)
  }
}
